import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import { homePathForUser, ROLE_LABELS } from '../utils/roles.js';

export function ImpersonationBanner() {
  const { user, stopImpersonation, impersonationLoading } = useAuth();
  const navigate = useNavigate();

  const imp = user?.impersonation;
  if (!imp?.active) {
    return null;
  }

  const viewing = imp.viewing_as;
  const roleLabel = ROLE_LABELS[viewing?.role] ?? viewing?.role;

  const onExit = async () => {
    try {
      const restored = await stopImpersonation();
      navigate(homePathForUser(restored), { replace: true });
    } catch (err) {
      window.alert(err?.message || 'Could not exit preview mode. Try signing in again.');
    }
  };

  return (
    <div className="impersonation-banner" role="status">
      <div className="impersonation-banner-inner">
        <span>
          Viewing as <strong>{viewing?.name}</strong> ({roleLabel}) · {viewing?.email}
        </span>
        <button
          type="button"
          className="btn btn-sm btn-light"
          onClick={() => void onExit()}
          disabled={impersonationLoading}
        >
          {impersonationLoading ? 'Returning…' : 'Exit preview'}
        </button>
      </div>
    </div>
  );
}
